import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { CATALOG_URL } from '@/api/catalog'

const COUNTRY_URL = `${CATALOG_URL}/countries`

const errors = createHandbookResponseErrors('страну', 'стран')

export const CountryApi = createNewHandbookApi(COUNTRY_URL, errors)
